function Tooltip({ text, width, whiteSpace, position }) {
  let className = ''
  let triangleClassName = ''
  if (position?.includes('top')) {
    className += 'bottom-[100%] mb-16'
    triangleClassName += 'top-[100%] rotate-180'
  }
  if (position?.includes('bottom')) {
    className += ' top-[100%] mt-16'
    triangleClassName += 'bottom-[100%]'
    triangleClassName += ' bottom-[100%]'
  }
  if (position?.includes('center')) {
    className += ' left-1/2 -translate-x-1/2'
    triangleClassName = ' left-1/2 -translate-x-1/2'
  }
  if (position?.includes('left')) {
    className += ' -right-16'
    triangleClassName += ' right-16'
  }
  if (position?.includes('right')) {
    className += " -left-16"
    triangleClassName += ' left-16'
  }
  return (
    <div className='relative group'>
      <i className='group-hover:text-primary transition-colors duration-200 icon icon-help-circle cursor-pointer block ml-8 text-greyLight3 w-[20px] h-[20px] text-lg flex items-center justify-center text-greyLight3' />
      <div
        className={
          'group-hover:block animate-[fadeIn_200ms_ease-in-out] duration-200 hidden bg-grey rounded-8 text-white absolute text-xs leading-xs px-12 py-6 z-10 ' +
          (whiteSpace ? 'whitespace-nowrap ' : ' ') +
          className
        }
        style={width ? { width: width + 'px' } : {}}
      >
        <div className={'w-0 h-0 border-[8px] absolute ' + triangleClassName} style={{
          borderColor: 'transparent transparent #31363D transparent',
        }}/>
        {text}
      </div>
    </div>
  )
}

Tooltip.defaultProps = {
  whiteSpace: true,
  position: 'bottom left'
}
export default Tooltip
